// src/hooks/useBatchedWrites.js
import { useRef, useCallback } from 'react';
import { writeBatch } from 'firebase/firestore';
import { db } from '../firebase';

export function useBatchedWrites(debounceMs = 500) {
  const queue = useRef([]);
  const timer = useRef(null);

  const queueWrite = useCallback((ref, payload, options = { merge: true }) => {
    queue.current.push({ ref, payload, options });

    clearTimeout(timer.current);
    timer.current = setTimeout(() => {
      const batch = writeBatch(db);
      queue.current.forEach(({ ref, payload, options }) => {
        if (options.merge) batch.set(ref, payload, { merge: true });
        else             batch.set(ref, payload);
      });
      queue.current = [];
      batch.commit().catch(console.error);
    }, debounceMs);
  }, [debounceMs]);

  const flush = useCallback(() => {
    clearTimeout(timer.current);
    if (!queue.current.length) return Promise.resolve();
    const batch = writeBatch(db);
    queue.current.forEach(({ ref, payload, options }) => {
      if (options.merge) batch.set(ref, payload, { merge: true });
      else             batch.set(ref, payload);
    });
    queue.current = [];
    return batch.commit();
  }, []);

  return { queueWrite, flush };
}
